import React, { useState } from 'react'
import { Modal, Button } from 'react-bootstrap';
import { FaTimesCircle } from 'react-icons/fa';

interface typeProps {
  title: string,
  textButton: string,
  children: JSX.Element[] | JSX.Element
}

export default function ModalStatic({ title, textButton, children }: typeProps) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  return (
    <>
      <div className='d-flex justify-content-end'>
        <button className='btn btn-secundary' id='btn-modal' onClick={handleShow}>{textButton}</button>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}>
        <Modal.Header>
          <Modal.Title><h5>{title}</h5></Modal.Title>
          <FaTimesCircle className='link' onClick={handleClose} />
        </Modal.Header>

        <Modal.Body>
          {children}
        </Modal.Body>

      </Modal>
    </>
  )
}
